import { AssigneeSelection } from '@chilipiper/api-client/src/concierge-fire'
import { DistributionHost } from '@chilipiper/api-client/src/team-scheduling'
import { RoundRobinExpectedHostV2, User1 } from '@chilipiper/api-client/src/user-availability'
import { BookerSettings } from './booker-settings'

const getHostIdFromBookerSettings = (bookerSettings?: BookerSettings) => {
  if (bookerSettings?.type === 'Host') {
    return bookerSettings.id
  }
  return undefined
}

export const getRoundRobinAndOwnershipExpectedHost = ({
  bookerSettings,
  firstAssignment,
}: {
  bookerSettings?: BookerSettings
  firstAssignment: { userId: string } | { distributionId: string }
}): RoundRobinExpectedHostV2 => {
  const hostId = getHostIdFromBookerSettings(bookerSettings)

  if (hostId) {
    return {
      userId: hostId,
      type: 'User',
    }
  }
  if ('userId' in firstAssignment) {
    return {
      userId: firstAssignment.userId,
      type: 'User',
    }
  }

  return {
    distributionId: firstAssignment.distributionId,
    type: 'AssigneeFromDistribution',
  }
}

export const getUserExpectedHost = ({
  bookerSettings,
  firstAssignment,
}: {
  bookerSettings?: BookerSettings
  firstAssignment: { userId: string }
}): User1 => {
  const hostId = getHostIdFromBookerSettings(bookerSettings)

  if (hostId) {
    return {
      userId: hostId,
      type: 'User',
    }
  }
  return {
    userId: firstAssignment.userId,
    type: 'User',
  }
}

export const convertExpectedHostToDistributionHost = (
  expectedHost: RoundRobinExpectedHostV2
): DistributionHost => {
  if (expectedHost.type === 'User') {
    return {
      type: 'User',
      id: expectedHost.userId,
    }
  }

  return {
    type: 'Assignee',
  }
}

export const getRoundRobinExpectedHostFromMultipleAssignments = ({
  bookerSettings,
  selectedAssignee,
}: {
  selectedAssignee: AssigneeSelection
  bookerSettings?: BookerSettings
}): RoundRobinExpectedHostV2 => {
  const hostId = getHostIdFromBookerSettings(bookerSettings)

  if (hostId) {
    return {
      userId: hostId,
      type: 'User',
    } satisfies RoundRobinExpectedHostV2
  }

  if (selectedAssignee.type === 'DistributedV3') {
    return {
      type: 'AssigneeFromDistribution',
      distributionId: selectedAssignee.distributionId,
    } satisfies RoundRobinExpectedHostV2
  }

  return {
    type: 'User',
    userId: selectedAssignee.id,
  } satisfies RoundRobinExpectedHostV2
}
